import { Injector } from '@angular/core';
import { ModelVariable } from '@wavemaker/variables';
import { WmsModelVariableService } from '@wms/variables';

export class WmsModelVariable extends ModelVariable {
  modelVariableService: WmsModelVariableService;

  constructor(selectedVariable: any, private injector: Injector) {
    super(selectedVariable);
    this.modelVariableService = this.injector.get(WmsModelVariableService);
  }

  __getVariableDependencies() {
    return this.modelVariableService.__beforeModelVariableDependencies();
  }

  __onPropertyChange(propertyName: string, value?: any) {
    return this.modelVariableService.__onPropertyChange(propertyName, value);
  }

  __getExternalTypes() {
    return this.modelVariableService.__getExternalTypes();
  }

  __isPrimitiveType(type: any) {
    return this.modelVariableService.__isPrimitiveType(type);
  }

  __isPreBuiltType(type: any) {
    return this.modelVariableService.__isPreBuiltType(type);
  }

  __updateBindingInfo(initBindings?: any) {
    return this.modelVariableService.__updateBindingInfo(initBindings);
  }

  __getBindingsByDataSet() {
    return this.modelVariableService.__getBindingsByDataSet();
  }

  __createBindingObjectIfNotExists(targetFieldName: any, type?: any) {
    return this.modelVariableService.__createBindingObjectIfNotExists(targetFieldName, type);
  }

  __getBindingsByType(initBindings: any) {
    return this.modelVariableService.__getBindingsByType(initBindings);
  }

  __removeDeletedNodes(keys: any) {
    return this.modelVariableService.__removeDeletedNodes(keys);
  }

}
